export default __webpack_public_path__ + "/dist/images/mail-share-icon.b5c15f2abc30d0dae0ada27ffde280ac.svg";